<template>
  <MultipleChoicesDropdown
    title="Stage"
    :value="startup.stage"
    :show-clear-all="false"
    :single-choice="true"
    :search-enabled="false"
    :choices="getStartupStages()"
    @change="onChange($event)"
  />
</template>

<script>
import { mapState } from 'vuex'
import { getStartupStages } from '@/services/startup-stages'

export default {
  computed: {
    ...mapState({
      startup: (state) => state.startupProfile.startup,
    }),
  },
  methods: {
    onChange(choice) {
      const attr = 'stage'
      const value = choice.value
      this.$store.commit('startupProfile/SET_STARTUP_ATTR', { attr, value })
    },
    getStartupStages() {
      return getStartupStages().map((choice) => {
        const help = getHelp(choice.value)
        return { ...choice, help }
      })
    },
  },
}

const HELP_MESSAGES = {
  idea:
    'You are preparing for doing the business - product conceptualization, market research, defining target groups, use cases, competition, risks, chances for success etc.',
  pre_seed: 'The first stage of a business - preparation of a prototype',
  seed:
    'Market entrance phase - final preparations and first users/clients acquisition, product-market fit validation, first revenues',
  early_growth:
    'Increase in revenue and market share. Preparation for scaling the business',
  growth:
    'Expanding the business activity to new markets - geographical expansion, differentiating the product to serve new client groups or expanding the offer for current target users',
  maturity:
    'Company with well established position on the market and significant market share',
}

function getHelp(stage) {
  return HELP_MESSAGES[stage] || ''
}
</script>
